import React from 'react';
import { TileTheme, useCurrentTheme } from '../themes';
import { Classes, Text, TileIntent, Title } from '../index';
import classNames from 'classnames';

export type TileProps = {
  className?: string;
  width?: number;
  height?: number;
  title?: string | React.ReactNode;
  subTitle?: string;
  extra?: React.ReactNode;
  icon?: React.ReactNode;
  onClick?: () => void;
  disableHover?: boolean;
  backgroundIntent?: TileIntent;
  children?: React.ReactNode;
};
export const Tile: React.FC<TileProps> = ({
  className,
  children,
  width = 1,
  height = 1,
  title,
  icon,
  extra,
  subTitle,
  onClick,
  disableHover,
  backgroundIntent,
}) => {
  let cls = classNames(Classes.TILE, className, {
    [Classes.HOVER_ITEM_CONTAINER]: !disableHover && onClick,
    [Classes.CLICK_CONTAINER]: onClick,
    //barevne variace
    [Classes.TILE_DANGER]: backgroundIntent === 'danger',
    [Classes.TILE_SUCCESS]: backgroundIntent === 'success',
    [Classes.TILE_WARNING]: backgroundIntent === 'warning',
    [Classes.TILE_INACTIVE]: backgroundIntent === 'inactive',
  });

  const titleCls = classNames({
    //barevne variace
    [Classes.TILE_TITLE_DANGER]: backgroundIntent === 'danger',
    [Classes.TILE_TITLE_SUCCESS]: backgroundIntent === 'success',
    [Classes.TILE_TITLE_WARNING]: backgroundIntent === 'warning',
    [Classes.TILE_TITLE_INACTIVE]: backgroundIntent === 'inactive',
  });

  const theme = useCurrentTheme();
  const size: TileTheme = React.useMemo(() => {
    const calculatedHeight =
      height * theme.tile.height + (height - 1) * theme.spacers[2];
    const calculatedWidth =
      width * theme.tile.width + (width - 1) * theme.spacers[2];

    return { height: calculatedHeight, width: calculatedWidth };
  }, [width, height]);
  return (
    <div
      onClick={onClick}
      className={cls}
      style={{ width: size.width, height: size.height }}
    >
      {(title || extra) && (
        <div className={Classes.TILE_HEADER}>
          {typeof title === 'string' ? (
            <Title
              type={'block'}
              className={titleCls}
              extra={extra}
              icon={icon}
              intent={'inherit'}
            >
              {title}
            </Title>
          ) : (
            <>{title}</>
          )}
        </div>
      )}
      {subTitle && (
        <div className={Classes.TILE_SUB_HEADER}>
          <Text intent={'secondary'}>{subTitle}</Text>
        </div>
      )}
      <div className={Classes.TILE_BODY}>
        <div className={Classes.TILE_CHILD_WRAPPER}>{children}</div>
      </div>
    </div>
  );
};
